import{css as t}from"lit";var i=t`cds-datalist input::-webkit-calendar-picker-indicator{opacity:0;cursor:text}`;export default i;
